import { Category } from "../types/category";
import { get } from "./fetch.core";

export async function getLevel1() {
  const res = await get<Category[]>("/pos/category/list");

  return res.data;
}

export async function getCategories2(parentId: string) {
  const res = parentId
    ? await get<Category[]>(`/pos/category/list?parentId=${parentId}`)
    : await get<Category[]>("/pos/category/list");

  return res.data;
}

export async function getCategories() {
  const filter = {
    // "codes[]": code,
    deep: 6,
  };

  const query = new URLSearchParams(filter as any).toString();

  const res = await get<Category[]>(`/pos/category/list?${query}`);

  return res.data;
}

export function groupByParent(categories: Category[]): Category[] {
  categories = [...categories];

  for (var i = 0; i < categories.length; i++) {
    const cat = categories[i];
    if (cat.parentId === undefined) continue;

    // find the parent
    const parentCat = categories.find((c) => c.id === cat.parentId);
    if (parentCat === undefined) continue;

    if (parentCat.children === undefined) {
      parentCat.children = [];
    }

    // don't add if already exist
    const childFound = parentCat.children.find((c) => c.id === cat.id);
    if (!childFound) parentCat.children.push(cat);
  }

  // now the tree is built.  remove those children from the first level
  return categories.filter((c) => c.parentId === undefined);
}

export async function getCategoryPath(categoryId: string) {
  const res = await get<Category[]>(`/pos/category/path?catId=${categoryId}`);
  return res.data;
}
